
// authActions.js
export const ACT_AUTH_NO_TOKEN_FOUND = 'ACT_AUTH_NO_TOKEN_FOUND';
export const ACT_AUTH_TOKEN_CHECK = 'ACT_AUTH_TOKEN_CHECK';
export const ACT_AUTH_TOKEN_SUCCESS = 'ACT_AUTH_TOKEN_SUCCESS';
export const ACT_AUTH_TOKEN_FAIL = 'ACT_AUTH_TOKEN_FAIL';
export const ACT_AUTH_TOKEN_EMPTY = 'ACT_AUTH_TOKEN_FAIL';
export const ACT_AUTH_LOGIN_FAILED = 'ACT_AUTH_LOGIN_FAILED';
export const ACT_AUTH_LOGIN_ATTEMPT = 'ACT_AUTH_LOGIN_ATTEMPT';
export const ACT_AUTH_LOGIN_SUCCESS = 'ACT_AUTH_LOGIN_SUCCESS';
export const ACT_AUTH_DEL_TOKEN = 'ACT_AUTH_DEL_TOKEN';
export const ACT_AUTH_LOGOUT_INIT = 'ACT_AUTH_LOGOUT_INIT';
export const ACT_AUTH_LOGOUT_SUCCESS = 'ACT_AUTH_LOGOUT_SUCCESS';


// employeesActions.js
export const ACT_EMP_ADD_INIT = 'ACT_EMP_ADD_INIT';
export const ACT_EMP_ADD_201 = 'ACT_EMP_ADD_201';
export const ACT_EMP_UPDATE_INIT = 'ACT_EMP_UPDATE_INIT';
export const ACT_EMP_UPDATE_200 = 'ACT_EMP_UPDATE_200';
export const ACT_EMP_DELETE = 'ACT_EMP_DELETE';
export const ACT_EMP_FETCH_INIT = 'ACT_EMP_FETCH_INIT';
export const ACT_EMP_FETCH_200 = 'ACT_EMP_FETCH_200';
